import { colorSet } from '../../../models/global-classes';

export interface ParsedColor {
  base: string;
  shade?: string;
  fullColor: string;
}

/**
 * Parses a color string into its components
 * Handles: "text-green", "text-green-500", "green", "green-500", "primary"
 */
export function parseColor(colorString: string | colorSet | undefined): ParsedColor {
  if (!colorString) {
    return { base: 'gray', shade: '700', fullColor: 'gray-700' };
  }

  let color = String(colorString).trim();

  if (color.startsWith('text-')) color = color.substring(5);
  if (color.startsWith('bg-')) color = color.substring(3);

  const parts = color.split('-');
  const base = parts[0];
  const shade = parts[1];

  return {
    base,
    shade,
    fullColor: shade ? `${base}-${shade}` : base
  };
}
